// RiskStatus Page - Uses generic module initialization patterns
// Demonstrates the streamlined approach for creating module pages

import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { riskStatusConfig } from './riskStatusConfig';
import { createRiskStatusValidation } from './riskStatusValidation';

/**
 * Initialize the riskStatus module using generic utilities
 * This pattern eliminates the need for separate initialization files
 */
const { config: initializedConfig } = initializeModule(
  riskStatusConfig,
  createRiskStatusValidation
);

/**
 * Create the RiskStatusPage using the generic module page factory
 * This eliminates the need for custom component wrappers
 */
const RiskStatusPage = createModulePage(
  initializedConfig,
  {
    displayName: 'RiskStatusPage',
    description: 'Risk Assessment Status Management System - Manage Risk Assessment statuses for tracking progress'
  }
);

export default RiskStatusPage;
